var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"display-inline-flex command-btn-like-design with-suffix"},[_c('div',{staticClass:"text-overflow-ellipsis pr-8",on:{"click":_vm.openLink}},[_vm._v(_vm._s(_vm.src))]),_c('div',{on:{"click":function($event){$event.preventDefault();return _vm.copyLinkToClipboard.apply(null, arguments)}}},[_c('LinkNotationSvg')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }